import i18n from '../../i18n';

export class Text {
  static get title(): string {
    return i18n._translate('Browse by category', {
      context: 'A heading above a row of links showing different categories of workouts to explore.',
    });
  }
}
